// eslint-disable-next-line no-unused-vars
import React from 'react';
import { object, string, func, bool } from 'prop-types';
import { Button, Loading } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { ChevronDown } from 'lucide-react';

const StyledContainer = styled.div`
  display: flex;
  align-items: stretch;
  max-width: 200px;
  width: 100%;
  font-size: 0.875em;
  min-height: 30px;
  max-height: 50px;
  position: relative;

  .addToWishlist,
  .more {
    width: 100%;
    max-width: 80%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    flex-grow: 1;
    margin: 0;
    justify-content: center;
    border: 1px solid ${ props => props.theme.products.colors.addToFavoriteBorder } !important;
    &:not(:disabled) {
      background-color: ${ props => props.theme.products.colors.addToFavorite };
      color: ${ props => props.theme.products.colors.addToFavoriteText };
    }

    .cds--loading {
      position: relative;
      left: 0;
      top: 0;
      width: 20px;
      height: 20px;
      margin: 0 10px 0 0;
    }
  }

  &.offerFirst {
    .addToWishlist,
    .more {
      border-color: #2f8675 !important;
      color: #236658 !important;
    }

    .addToWishlist:not(:disabled) {
      background-color: #e8f5f1;
    }
  }

  .more {
    color: ${ props => props.theme.products.colors.addToFavoriteText } !important;
    background-color: ${ props => props.theme.colors.white } !important;
    border-left: 0 !important;
    max-width: 20%;
    min-width: 0;
    padding: 0;
    svg {
      margin: 0 auto;
    }
  }

  .cds--dropdown__wrapper {
    display: flex;
    min-height: 100%;
    width: 100%;
    min-width: 20%;
    border: 0;

    .wishlistsDropdown {
      min-height: 100%;
      outline: 0;
      width: 100%;
      border: 0;
      position: initial;
    }

    .cds--list-box__field {
      // &:not(:disabled) {
      //   background-color: ${ props => props.theme.colors.white };
      // }
      position: relative;
      padding: 0;
      width: calc(100% + 1px);
      min-height: 100%;
      height: 100%;
      margin: 0;
      left: -1px;
      border: 1px solid ${ props => props.theme.products.colors.addToFavoriteBorder };
      min-width: 0;
      outline: 0;

      //.cds--list-box__label {
      //  display: none;
      //}

      .cds--list-box__menu-icon {
        right: 0;
        background-color: ${ props => props.theme.colors.white };
        width: 100%;
        height: 100%;

        &--open {
          transform: none;

          svg {
            transition: transform 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
            transform: rotate(180deg);
          }
        }

        svg {
          stroke: ${ props => props.theme.products.colors.addToFavoriteText };
        }
      }
    }

    .cds--list-box__menu {
      width: auto;
      min-width: 0;
      max-height: 200px;
      left: auto;
      overflow: auto;
      outline: 0;

      .cds--list-box__menu-item__option {
        color: ${ props => props.theme.colors.gray };
        svg {
          display: none;
        }
      }

      .cds--list-box__menu-item {
        background-color: transparent !important;
        .cds--list-box__menu-item__option {
          border-top: 0 !important;
          border-bottom: 1px solid #e0e0e0 !important;
        }
        &:last-of-type {
          border-bottom: 0 !important;
          color: inherit;
        }
      }
    }
  }
`;
//
// const StyledButton = styled(Button)`
//   &:before {
//     display: ${ props => props.theme.canCreate ? 'block' : 'none' };
//     content: "+";
//     margin-right: 5px;
//   }
//   &:hover, &:active, &:focus {
//     background-color: transparent !important;
//     color: ${ props => props.theme.colors.darkGray };
//   }
//   display: flex;
//   align-items: center;
//   justify-content: flex-start !important;
//   width: 100%;
//   max-width: none !important;
//   padding: 0 !important;
//   margin: 0 !important;
//   height: auto !important;
//   min-height: 0 !important;
//   border-top: ${ props => props.theme.canCreate ? `1px solid ${props.theme.colors.ligthGray}` : '' };
//   color: ${ props => props.theme.colors.gray };
//
//   svg {
//     margin-right: 10px !important;
//   }
// `;

const AddToWishlistMenu = ({
  loading,
  label,
  onOpenModal,
  onAddToWishlist,
  action,
  offerFirst,
  ...rest
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <StyledContainer
      theme={ theme }
      // canCreate={ canCreate }
      // hasDefault={ hasDefault }
      hasLabel={ label?.length > 0 }
      { ...rest }
      className={ `addToWishlistContainer ${ offerFirst ? 'offerFirst' : '' }` }
    >
      <Button
        className="addToWishlist"
        kind="ghost"
        onClick={ action === 'move' ? onOpenModal : onAddToWishlist }
        disabled={ loading || rest.disabled }
      >
        { loading && <Loading active={ loading } small withOverlay={ false } /> }
        { label || t('products.addToWishlist') }
      </Button>
      <Button
        className="more"
        kind="ghost"
        onClick={ onOpenModal }
      >
        <ChevronDown />
      </Button>
      {/*{ hasDefault && (*/}
      {/*  <Button*/}
      {/*    className="addToWishlist"*/}
      {/*    kind="ghost"*/}
      {/*    onClick={ onAddToWishlist }*/}
      {/*    disabled={ loading || rest.disabled }*/}
      {/*  >*/}
      {/*    { loading && <Loading active={ loading } small withOverlay={ false } /> }*/}
      {/*    { t('products.addToWishlist') }*/}
      {/*  </Button>*/}
      {/*) }*/}
      {/*<Dropdown*/}
      {/*  disabled={ loading }*/}
      {/*  className="wishlistsDropdown"*/}
      {/*  id={ uniqueId('wishlists') }*/}
      {/*  label={ label }*/}
      {/*  type={ type }*/}
      {/*  items={ items }*/}
      {/*  itemToElement={ item => {*/}
      {/*    if (item.createButton) {*/}
      {/*      return (*/}
      {/*        <StyledButton*/}
      {/*          theme={{ ...theme, canCreate }}*/}
      {/*          kind="ghost"*/}
      {/*          onClick={ item.onClick }*/}
      {/*          style={{ fontWeight: 700 }}*/}
      {/*        >*/}
      {/*          <IconPlus />*/}
      {/*          { t('wishlists.newList') }*/}
      {/*        </StyledButton>*/}
      {/*      );*/}
      {/*    }*/}
      {/*    return (*/}
      {/*      <StyledButton*/}
      {/*        kind="ghost"*/}
      {/*        onClick={ () => onAddToWishlist({ selectedItem: item }) }*/}
      {/*      >*/}
      {/*        { item.name || item.label || item.text }*/}
      {/*      </StyledButton>*/}
      {/*    );*/}
      {/*  } }*/}
      {/*/>*/}
    </StyledContainer>
  );
};

AddToWishlistMenu.propTypes = {
  action: string,
  onAddToWishlist: func,
  selectedProduct: object,
  onOpenModal: func,
  loading: bool,
  label: string,
  offerFirst: bool,
};

export default AddToWishlistMenu;
